var IMAGE_RESIZE = {
  CROP: 'fill',
  FIT: 'fit'
};
export default IMAGE_RESIZE;